import Vue from 'vue'
import VueRouter from 'vue-router'

import guards from './guards'
import { roles } from './utils/auth'
import LocalIndex from './views/local/LocalIndex'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LocalIndex,
    beforeEnter: guards.auth,
  },
  {
    path: '/set-password-login',
    name: 'SetPasswordLogin',
    component: () => import('./views/auth/SetPasswordLogin.vue'),
    beforeEnter: guards.authWithNoFirstLogin,
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/auth/Login'),
    beforeEnter: guards.onlyNoAuthenticated,
  },
  {
    path: '/local',
    name: 'LocalIndex',
    component: () => import('./views/local/LocalIndex'),
    beforeEnter: guards.auth,
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('./views/usuarios/UsuarioIndex'),
    beforeEnter: guards.admin,
  },
  {
    path: '/usuarios/criar',
    name: 'usuariosNovo',
    component: () => import('./views/usuarios/UsuarioEditar'),
    beforeEnter: guards.admin,
  },
  {
    path: '/usuarios/editar/:userId',
    name: 'usuariosEditar',
    component: () => import('./views/usuarios/UsuarioEditar'),
    beforeEnter: guards.admin,
  },
  {
    path: '/usuarios/password/:userId',
    name: 'usuariosTrocarSenha',
    component: () => import('./views/usuarios/UsuarioTrocarSenha'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId(\\d+)',
    name: 'LocalEditar',
    component: () => import('./views/local/LocalEditar'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/detalhe',
    name: 'LocalDetalhe',
    component: () => import('./views/equipamento-campo/EquipamentoDetalhe'),
    beforeEnter: guards.auth,
  },
  {
    path: '/local/criar',
    name: 'LocalNovo',
    component: () => import('./views/local/LocalNovo'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/equipamento/mapa',
    name: 'EquipamentoMapaIndex',
    component: () => import('./views/equipamento-campo/EquipamentoMapaIndex'),
    beforeEnter: guards.hasOneRole([roles.MAPA_VISUALIZAR, roles.MAPA_EDICAO]),
  },
  {
    path: '/local/:localId/equipamento/criar',
    name: 'EquipamentoCampoNovo',
    redirect: (to) => ({
      name: 'EquipamentoCampoTemplate',
      params: { localId: to.params.localId },
    }),
  },
  {
    path: '/local/:localId/equipamento/:equipamentoId/editar',
    name: 'EquipamentoCampoEditar',
    component: () => import('./views/equipamento-campo/EquipamentoEditar'),
    beforeEnter: guards.hasOneRole([
      roles.EQUIPAMENTO_EDITAR,
      roles.CMD_AUTO_EDICAO,
      roles.CALIBRACAO_EDICAO,
    ]),
  },
  {
    path: '/local/:localId/equipamento/:equipamentoId/editar*',
    component: () => import('./views/equipamento-campo/EquipamentoEditar'),
    beforeEnter: guards.hasOneRole([
      roles.EQUIPAMENTO_EDITAR,
      roles.CMD_AUTO_EDICAO,
      roles.CALIBRACAO_EDICAO,
    ]),
  },
  {
    path: '/local/:localId/equipamento/:equipamentoId/sensor/novo',
    name: 'EquipamentoSensorNovo',
    component: () =>
      import('./views/equipamento-campo/EquipamentoSensorForm.vue'),
    beforeEnter: guards.isRole(roles.EQUIPAMENTO_EDITAR),
  },
  {
    path: '/local/:localId/equipamento/:equipamentoId/sensor/:sensorId/editar',
    name: 'EquipamentoSensorEditar',
    component: () =>
      import('./views/equipamento-campo/EquipamentoSensorForm.vue'),
    beforeEnter: guards.hasOneRole([
      roles.EQUIPAMENTO_EDITAR,
      roles.CALIBRACAO_EDICAO,
    ]),
  },
  // Acao
  {
    path: '/local/:localId/equipamento/:equipamentoId/acao/novo',
    name: 'EquipamentoAcaoNovo',
    component: () =>
      import('./views/equipamento-campo/EquipamentoAcaoForm.vue'),
    beforeEnter: guards.isRole(roles.EQUIPAMENTO_EDITAR),
  },
  {
    path: '/local/:localId/equipamento/:equipamentoId/acao/:acaoId/editar',
    name: 'EquipamentoAcaoEditar',
    component: () =>
      import('./views/equipamento-campo/EquipamentoAcaoForm.vue'),
    beforeEnter: guards.isRole(roles.EQUIPAMENTO_EDITAR),
  },
  {
    path: '/local/:localId/sig',
    name: 'PontoSigIndex',
    component: () => import('./views/ponto-sig/PontoSigMapBoxIndex.vue'),
    beforeEnter: guards.isRole(roles.ENVIAR_DADOS_SIG),
  },
  {
    path: '/tipo-sensor/',
    name: 'TipoSensorIndex',
    component: () => import('./views/tipo-sensor/TipoSensorIndex'),
    beforeEnter: guards.admin,
  },
  {
    path: '/admin/domain-events',
    name: 'DomainEventIndex',
    component: () => import('./views/admin/DomainEventIndex.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/notificacao',
    name: 'NotificacaoIndex',
    component: () => import('./views/notificacao/NotificacaoIndex'),
    beforeEnter: guards.isRole(roles.NOTIFICACAO),
  },
  {
    path: '/local/:localId/notificacao/criar',
    name: 'NotificacaoNovo',
    component: () => import('./views/notificacao/NotificacaoInput'),
    beforeEnter: guards.isRole(roles.NOTIFICACAO),
  },
  {
    path: '/local/:localId/notificacao/:notificacaoId/editar',
    name: 'NotificacaoEditar',
    component: () => import('./views/notificacao/NotificacaoInput'),
    beforeEnter: guards.isRole(roles.NOTIFICACAO),
  },
  {
    path: '/local/:localId/notificacao/acompanhar',
    name: 'NotificacaoLogIndex',
    component: () => import('./views/notificacao/log/NotificacaoLogIndex'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/notificacao/:notificacaoId/detalhes',
    name: 'NotificacaoLogDetalhe',
    component: () => import('./views/notificacao/log/NotificacaoLogDetalhe'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/pessoa',
    name: 'PessoaIndex',
    component: () => import('./views/pessoa/PessoaIndex'),
    beforeEnter: guards.isRole(roles.CARGOS),
  },
  {
    path: '/local/:localId/pessoa/cargo/criar',
    name: 'CargoNovo',
    component: () => import('./views/pessoa/CargoInput'),
    beforeEnter: guards.isRole(roles.CARGOS),
  },
  {
    path: '/local/:localId/pessoa/cargo/:cargoId/editar',
    name: 'CargoEditar',
    component: () => import('./views/pessoa/CargoInput'),
    beforeEnter: guards.isRole(roles.CARGOS),
  },
  {
    path: '/local/:localId/dashboard',
    name: 'DashboardIndex',
    component: () => import('./views/dashboard/DashboardIndex'),
    beforeEnter: guards.auth,
  },
  {
    path: '/local/:localId/view',
    name: 'ViewIndex',
    component: () => import('./views/view/ViewIndex.vue'),
    beforeEnter: guards.hasOneRole([
      roles.ADMIN,
      roles.VIEW,
      roles.VIEW_VISUALIZAR,
    ]),
  },
  {
    path: '/local/:localId/view/:viewId/componentes',
    name: 'ViewComponentes',
    component: () => import('./views/view/ViewComponentes.vue'),
    beforeEnter: guards.hasOneRole([roles.ADMIN, roles.VIEW]),
    props: { editView: true },
  },

  {
    path: '/local/:localId/view/:viewId/show',
    name: 'ViewComponentesShow',
    component: () => import('@/wrappers/view/ViewComponentesWrapper.vue'),
    beforeEnter: guards.hasOneRole([
      roles.ADMIN,
      roles.VIEW,
      roles.VIEW_VISUALIZAR,
    ]),
    props: { editView: false },
  },
  {
    path: '/local/:localId/view/graphical',
    name: 'GraphicalIndex',
    component: () => import('./views/view/graphical-view/GraphicalIndex.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/view/graphical/:graphicalId',
    name: 'GraphicalViewFile',
    component: () =>
      import('./views/view/graphical-view/GraphicalViewFile.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/epanetadmin',
    name: 'EpanetAdmin',
    component: () => import('./views/epanet/EpanetAdmin.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/heatmap',
    name: 'EpanetHeatmapIndex',
    component: () => import('./views/epanet/EpanetHeatmapIndex.vue'),
    beforeEnter: guards.isRole(roles.EPANET),
  },
  {
    path: '/apk',
    name: 'ApkVersionIndex',
    component: () => import('./views/apk-version/ApkVersionIndex.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/apk/criar',
    name: 'ApkVersionCreate',
    component: () => import('./views/apk-version/ApkVersionCreate.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/local/:localId/sensor-virtual',
    name: 'SensorVirtualIndex',
    component: () => import('./views/sensor-virtual/SensorVirtualIndex.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/local/:localId/sensor-virtual/create',
    name: 'SensorVirtualCreate',
    component: () => import('./views/sensor-virtual/SensorVirtualInput.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/local/:localId/sensor-virtual/:sensorVirtualId/editar',
    name: 'SensorVirtualEdit',
    component: () => import('./views/sensor-virtual/SensorVirtualInput.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/local/:localId/equipamento/:equipamentoId/codigo-integracao',
    name: 'CodigoIntegracaoEquipamento',
    component: () =>
      import('./views/equipamento-campo/CodigoIntegracaoEquipamento.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/local/:localId/equipamento/criar/template',
    name: 'EquipamentoCampoTemplate',
    component: () =>
      import('./views/equipamento-campo/EquipamentoCampoTemplate.vue'),
    beforeEnter: guards.isRole(roles.EQUIPAMENTO_CRIAR),
  },
  {
    path: '/equipamento/template',
    name: 'EquipamentoTemplateIndex',
    component: () =>
      import('./views/equipamento-template/EquipamentoTemplateIndex.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/equipamento/template/criar',
    name: 'EquipamentoTemplateCriar',
    component: () =>
      import('./views/equipamento-template/EquipamentoTemplateInput.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/equipamento/template/editar/:templateId',
    name: 'EquipamentoTemplateEditar',
    component: () =>
      import('./views/equipamento-template/EquipamentoTemplateInput.vue'),
    beforeEnter: guards.isRole(roles.ADMIN),
  },
  {
    path: '/local/:localId/auditoria-acoes',
    name: 'AuditoriaAcoes',
    component: () => import('./views/auditoria/AuditoriaAcoes.vue'),
    beforeEnter: guards.auth,
  },
  {
    path: '/local/:localId/auditoria-notificacoes',
    name: 'AuditoriaNotificacoes',
    component: () => import('./views/auditoria/AuditoriaNotificacoes.vue'),
    beforeEnter: guards.auth,
  },
  {
    path: '/local/:localId/eta',
    name: 'EtaIndex',
    component: () => import('./views/eta/EtaIndex.vue'),
    beforeEnter: guards.hasOneRole([
      roles.ADMIN,
      roles.ETA_OPERADOR,
      roles.ETA_RELATORIO,
    ]),
  },
  {
    path: '/local/:localId/criar',
    name: 'EtaCriar',
    component: () => import('./views/eta/EtaForm.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/editar/:etaId',
    name: 'EtaEditar',
    component: () => import('./views/eta/EtaForm.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/eta/:etaId/pontos',
    name: 'EtaPontos',
    component: () => import('./views/eta/EtaPontosForm.vue'),
    beforeEnter: guards.admin,
  },
  {
    path: '/local/:localId/eta/:etaId/visualizar',
    name: 'EtaVisualizar',
    component: () => import('./views/eta/EtaVisualizar.vue'),
    beforeEnter: guards.hasOneRole([roles.ETA_OPERADOR, roles.ETA_RELATORIO]),
  },
  {
    path: '/local/:localId/eta/:etaId/medicao/:periodicidade',
    name: 'EtaMedicao',
    component: () => import('./views/eta/EtaMedicao.vue'),
    beforeEnter: guards.hasOneRole([roles.ETA_OPERADOR, roles.ETA_RELATORIO]),
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
